import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { provideListView } from '@y42/core/list-view';
import { AbstractJobService } from '../../api/job.service';
import { JobListViewModule } from '../job-list-view/job-list-view.module';
import { JobListViewService } from './job-list-view.service';

@Component({
  selector: 'y42-job-dialog',
  template: `<y42-job-list-view [id]="'datasource-table-job'"></y42-job-list-view>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideListView(JobListViewService)],
  imports: [CommonModule, JobListViewModule],
  standalone: true,
})
export class JobDialogComponent {
  constructor(jobService: AbstractJobService) {
    jobService.refreshJobs();
  }
}
